import { Typography } from 'antd';

const { Paragraph, Text } = Typography;

const AutoReplaceAssetMessage = () => {
  return (
    <>
      <Paragraph style={{ textAlign: 'left' }}>
        You are creating asset(s) with{' '}
        <Text strong>Auto Apply/Replace on Product</Text> function. This action
        may automatically replace existing assets that were collected during an{' '}
        <Text strong>IX-ONE capture</Text> event. Many of our retailer and
        distributor partners will only accept{' '}
        <Text strong>IX-ONE Certified</Text> content. Removing this
        certification may cause one or more of your partners to reject your
        product information.
      </Paragraph>
      <Paragraph style={{ textAlign: 'left' }}>
        To restore <Text strong>IX-ONE Certified</Text> status, a recapture of
        your product would be required.{' '}
        <Text strong>
          Are you sure you wish to proceed and remove your IX-ONE certification
        </Text>
        ?
      </Paragraph>
    </>
  );
};

export default AutoReplaceAssetMessage;
